/** Standard Bhagavad Gita verse counts (700 total). */
export const GITA_VERSE_COUNTS = {
  1: 47,
  2: 72,
  3: 43,
  4: 42,
  5: 29,
  6: 47,
  7: 30,
  8: 28,
  9: 34,
  10: 42,
  11: 55,
  12: 20,
  13: 34,
  14: 27,
  15: 20,
  16: 24,
  17: 28,
  18: 78,
};

const SLOKA_REF_PATTERN = /^(\d{1,2})-(\d{1,2})$/;

export function parseSlokaRef(ref) {
  if (!ref || typeof ref !== 'string') return null;
  const match = ref.match(SLOKA_REF_PATTERN);
  if (!match) return null;

  const chapter = Number(match[1]);
  const verse = Number(match[2]);
  const maxVerse = GITA_VERSE_COUNTS[chapter];

  if (!maxVerse || verse < 1 || verse > maxVerse) return null;

  return { chapter, verse, ref: `${chapter}-${verse}` };
}

export function listAllSlokaRefs() {
  const refs = [];
  for (let chapter = 1; chapter <= 18; chapter += 1) {
    const count = GITA_VERSE_COUNTS[chapter];
    for (let verse = 1; verse <= count; verse += 1) {
      refs.push(`${chapter}-${verse}`);
    }
  }
  return refs;
}
